export function sumCompletedOrders(dailyList) {
  if (!Array.isArray(dailyList)) return 0;
  return dailyList.reduce((sum, d) => sum + (parseInt(d?.total_order_count, 10) || 0), 0);
}
